import Script from 'next/script'

export const ShopifyConsentTrackingScript: React.FC = () => {
    return (
        <Script
            id="shopify-consent-tracking"
            strategy="lazyOnload"
            src="https://cdn.shopify.com/shopifycloud/consent-tracking-api/v0.1/consent-tracking-api.js"
        />
    )
}
